import { Grid } from '@material-ui/core';
import { DataPathContextProvider, useDataPath } from '../../context';
import { CustomViewRegister } from '../CustomView';

CustomViewRegister.register({
  id: 'sequence',
  function: function SequenceView(props: Record<string, any>) {
    const list = useDataPath(props.path) || [];
    return list.map((_: any, idx: number) => {
      const index = `${props.path}[${idx}]`;
      return (
        <DataPathContextProvider key={String(idx)} path={index}>
          {props.children}
        </DataPathContextProvider>
      );
    });
  },
});

CustomViewRegister.register({
  id: 'grid_sequence',
  function: function GridSequenceView(props: Record<string, any>) {
    const list = useDataPath(props.path) || [];
    return list.map((_: any, idx: number) => {
      const index = `${props.path}[${idx}]`;
      return (
        <Grid container spacing={props.spacing || 3} key={String(idx)}>
          <DataPathContextProvider path={index}>
            <Grid item xs={12}>
              {props.children}
            </Grid>
          </DataPathContextProvider>
        </Grid>
      );
    });
  },
});
